<template>
  <div class="box">
    <h2 class="title is-4 has-text-centered">
      {{ type | toTitleCase }}
    </h2>

    <progress class="progress" :class="progressClass" :value="status" :max="items.length"></progress>

    <div class="columns">
      <div class="column has-text-centered" v-for="item in items" :key="item">
        <b-tooltip
          :label="getToolTipLabel(item)"
          position="is-bottom"
          type="is-dark"
        >
          <p class="button" :class="{ 'is-success': isComplete(item) }">
            <fa-icon :icon="getIcon(item)"></fa-icon>
          </p>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Library from '@/library'

export default {
  name: 'DevelopmentProgressItem',

  props: {
    type: {
      required: true
    }
  },

  methods: {
    getToolTipLabel (item) {
      return `${Library.Filters.toTitleCase(this.type)} has a ${Library.Filters.toTitleCase(item)} function.`
    },

    getIcon (item) {
      switch (item) {
        case 'SearchCard':
          return 'search'
        case 'ViewPart':
          return 'th'
        case 'Create':
          return 'plus'
        case 'Details':
          return 'pencil-alt'
        default:
          return 'question-circle'
      }
    },

    isComplete (item) {
      if (item === 'SearchCard') {
        if (Library.Entities.getSearchCard(this.type)) {
          return true
        } else {
          return false
        }
      }

      if (item === 'ViewPart') {
        return Library.Entities.hasViewPartComponent(this.type)
      }

      if (item === 'Create') {
        if (Library.Entities.hasCreate(this.type)) {
          return true
        } else {
          return false
        }
      }

      if (item === 'Details') {
        if (Library.Entities.hasView(this.type)) {
          return true
        } else {
          return false
        }
      }

      return false
    }
  },

  computed: {
    items () {
      const items = []

      if (this.type === Library.Enums.ObjectType.PlasticProduct || this.type === Library.Enums.ObjectType.Animal) {
        items.push('Create', 'Details', 'SearchCard')
        return items
      }

      if (this.type.endsWith('Count') || this.type === Library.Enums.ObjectType.Point) {
        items.push('ViewPart')
        return items
      }

      if (Library.Entities.getSearchableEntities().indexOf(this.type) !== -1) {
        items.push('Create', 'Details')
        items.push('SearchCard', 'ViewPart')
      } else {
        switch (this.type) {
          case Library.Enums.ObjectType.Comment:
          case Library.Enums.ObjectType.Query:
          case Library.Enums.ObjectType.Stop:
            items.push('ViewPart')
            break
          default:
            items.push('SearchCard', 'ViewPart')
            break
        }
      }

      return items
    },

    status () {
      let status = 0

      this.items.forEach((item) => {
        if (this.isComplete(item)) {
          status++
        }
      })

      return status
    },

    progressClass () {
      if (this.items.length > 0) {
        const percentage = (this.status / this.items.length) * 100

        if (percentage < 35) {
          return 'is-danger'
        } else if (percentage < 100) {
          return 'is-warning'
        } else {
          return 'is-success'
        }
      }

      return null
    }
  }
}
</script>
